<template>
  <div class="home">
    <!--轮播图-->
    <div style="min-width:1200px;">
     <el-carousel trigger="click" height="600px">
       <el-carousel-item v-for="item in bantu" :style="`background:url('http://upload.lusenky.com/upload/img/${item}') top center`" :key="item">

       </el-carousel-item>
    </el-carousel>
    </div>
    <!--五大服务优势-->
    <div class="fuwu">
       <div>
          <p class='p1'>六大主营方向</p>
          <p class='p2'>为您提供更有保障的服务而努力</p>
          <div class="mokuai">
             <div class="div1 img1" >
               <div class="img11" style="width:52px;height:52px;margin:0 auto;margin-top:10px;"></div>
               <h3 style="padding:15px 0;text-align:center;">物联网</h3>
             </div>
             <div class="div1 img2"  >
               <div class="img22" style="width:52px;height:52px;margin:0 auto;margin-top:10px;"></div>
               <h3 style="padding:15px 0;text-align:center;">雷电产品</h3>
             </div>
             <div class="div1 img3"  >
              <div class="img33" style="width:52px;height:52px;margin:0 auto;margin-top:10px;"></div>
               <h3 style="padding:15px 0;text-align:center;">军用装备</h3>
             </div>
             <div class="div1 img4"  >
               <div class="img44" style="width:52px;height:52px;margin:0 auto;margin-top:10px;"></div>
               <h3 style="padding:15px 0;text-align:center;">系统集成</h3>
             </div>
             <div class="div1 img5"  >
               <div class="img55" style="width:52px;height:52px;margin:0 auto;margin-top:10px;"></div>
               <h3 style="padding:15px 0;text-align:center;">建筑工程</h3>
             </div>
             <div class="div1 img6"  >
               <div class="img66" style="width:52px;height:52px;margin:0 auto;margin-top:10px;"></div>
               <h3 style="padding:15px 0;text-align:center;">通讯工程</h3>
             </div>
          </div>
       </div>
    </div>
    <!--产品和解决方案-->
     <div style="margin-bottom:10px;">
       <p class='p1'>产品和解决方案</p>
       <p class='p2'>标准产品+个性化服务，帮您彻底解决困扰</p>
       <!--面板切换-->
       <div class="mian">
         <ul style="background:#d9d9d9;">
           <div class="Lightning"> <img src="../assets/fenlei.png" alt="" style="width:28px;height:20px;"> 防雷产品</div>
           <li style="margin:35px 0;" v-for="(item,i) of lity" :key="i" :class="ishow==item.id?'li':''" @mouseenter="ishowmian(item.id)">
             <span class="sanjiao"></span>
             {{item.name}}
           </li>
         </ul>
         <div>
           <span class="more" @click="$router.push('/chan')">更多>></span>
             <div @click="$router.push('/xiang/chanx?type='+item.gtype+'&id='+item.id)" v-for="(item,i) of limian" :key="i" class="kuai">
               <img width="145px" height="145px" v-lazy="`http://upload.lusenky.com/upload/good/${item.imgpath}`" alt="">
               <div  class="kuai-jie">
                 <h4 class="overflow:hidden;">{{item.name}}</h4>
                 <p>{{item.modName}}</p>
                 <div class="btn">查看详情</div>
               </div>
             </div>
         </div>
       </div>
     </div>
     <!--工作案例-->
     <p id="gong" class='p1'>工程案例</p>
     <p class='p2'>团队作战，保质保量交付项目成果</p>
     <div class="work">
       <div style="margin-bottom:40px;" v-for="(item,i) of imgg" :key='i'>
         <img width="210px" style="margin-bottom:10px" height="157px" v-lazy="`http://upload.lusenky.com/upload/img/${item.path}`" alt="">
         <p style="text-align:center;margin-bottom:10px;">{{item.title}}</p>         
       </div>
     </div>
     <!--检测案例-->
     <!-- <p id="jian" class='p1'>检测案例</p>
     <p class='p2'>团队作战，保质保量交付项目成果</p>
     <div  class="work">
       <div style="margin-bottom:40px;" v-for="(item,i) of imgc" :key="i">
         <img width="210px" style="margin-bottom:10px" height="157px" v-lazy="`http://upload.lusenky.com/upload/img/${item.path}`"   alt="">
         <p style="text-align:center;margin-bottom:10px;">{{item.title}}</p>
       </div>
     </div> -->
     <!--新闻中心-->
     <p class='p1'>新闻中心</p>
     <p class='p2'>了解更多资讯</p>
     <div class="xinwen">
        <el-carousel trigger="click" height="235px">
          <el-carousel-item style="cursor: pointer;" v-for="(item,i) in newal" :key="i">
           <div @click="$router.push('/hang/gonx/'+item.id)" class="xin">
             <!--左边图片-->
             <div><img width="235px" height="235px" :src="item.nimg!=undefined?`http://upload.lusenky.com/upload/${item.nimg}`:''" alt="">
              <div style="width:235px;" class="yi">
                <p style="margin:10px 0;"  v-html='item.title'>{{item.title}}</p>
                <p style="color:red;" v-html='item.addtime'>{{item.addtime}}</p>
              </div>
             </div>
             <!--右边资讯-->
             <div class="right">
               <h2>{{item.title}}</h2>
               <p style="overflow: hidden;height:144px;line-height:37px;margin-top:10px;" v-html="item.content">{{item.content}}</p>
             </div>
           </div>
          </el-carousel-item>
        </el-carousel>   
     </div>
     <!--荣誉资质-->
     <p class='p1'>荣誉资质</p>
     <p class='p2'>获得众多合规资质</p>
     <div class="rong" @mouseenter="clti()" @mouseleave="marginLe()">
       <div :style="`margin-left:-${marginL}px`">
        <div v-for="(item,is) of imgz" :key='is'><img width="100%" v-lazy="`http://upload.lusenky.com/upload/img/${item}`" alt=""></div>
       </div>
     </div>
     <!-- <div id="box">
<div id="con1" ref="con1" :class="{anim:animate==true}" @mouseenter="mEnter" @mouseleave="mLeave">
<p v-for='item in items' :key="item">{{item.name}}</p>
</div> -->
<!-- </div> -->
     <!--固定定位的-->
     <div v-show="sollto>5000000" class="fixed">

     </div>
  </div>
</template>

<script>
import { setTimeout } from 'timers';
export default {
   data(){
     return{
       /*底部轮播*/
       animate:false,
      items:[ //消息列表对应的数组
      {name:"马云"},
      {name:"雷军"},
      {name:"王勤1"},
      {name:"王勤2"},
      {name:"王勤3"},
      {name:"王勤4"},
      {name:"王勤5"},
],
       time:'',
       aa:true,
       marginL:0,
       /**/ 
       kuan:true,
       sollto:1,
       ishow:1,
       bantu:['banner3.jpg','banner1.jpg','banner2.jpg'],
        imgg:[
          {title:'古建',path:'gong1.jpg'},
          {title:'中石油液化天然气防雷',path:'gong2.jpg'},
          {title:'某部队',path:'gong3.jpg'},
          {title:'气象观测站',path:'gong4.jpg'},
          {title:'气象观测站',path:'gong5.jpg'},
          {title:'三河市新宏昌',path:'gong6.jpg'},
          {title:'国家无线电检测中心',path:'gong7.jpg'},
          {title:'北京航天试验技术研究所',path:'gong8.jpg'},
          {title:'北京环境特性研究所',path:'gong9.jpg'},
          {title:'中原油田现场',path:'gong10.jpg'}
          ],
          imgc:[
         {title:'仿古建筑',path:'jian1.jpg'},
          {title:'风力发电',path:'jian2.png'},
          {title:'工厂',path:'jian3.jpg'},
          {title:'光伏阵列',path:'jian4.png'},
          {title:'航天系统',path:'jian5.jpg'},
          {title:'居民楼',path:'jian6.jpg'},
          {title:'商务楼',path:'jian7.jpg'},
          {title:'生产车间',path:'jian8.jpg'},
          {title:'通讯',path:'jian9.jpg'},
          {title:'学校',path:'jian10.jpg'}
          ],
          biao:[
            {title:'防雷产品',path:'biao1.jpg'},
            {title:'防雷工程',path:'biao2.jpg'},
            {title:'防雷检测',path:'biao3.jpg'},
            {title:'智能化',path:'biao6.jpg'},
            {title:'防雷监测',path:'biao5.jpg'},
            {title:'露森科研',path:'biao4.jpg'}
          ],
          imgz:['zi1.jpg','zi2.jpg','zi3.jpg','zi10.jpg','zi7.jpg','zi8.jpg','zi5.jpg','zi6.jpg','zi4.jpg','zi9.jpg'],
          /*新闻资讯数据 */
         newal:[],
         /*面板切换数据 */
         lity:[],
         limian:[],
     }    
   },
//    mounted () {
      // this.timer1= setInterval(this.scroll,1000)
// },
   methods:{
//      scroll(){
//         let con1 = this.$refs.con1;
//         con1.style.marginTop='-30px';
//         this.animate=!this.animate;
//         var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
//         setTimeout(function(){
//         that.items.push(that.items[0]);
//         that.items.shift();
//         con1.style.marginTop='0px';
//         that.animate=!that.animate; // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
//         },1000)
//         },
//         mEnter () {
        
//         clearInterval(this.timer1)

//         },
//         mLeave () {
        
//         this.timer1= setInterval(this.scroll,1000)
// },

     /*监听window高度*/
     winon(){
         if(this.kuan){
          this.kuan=false
          this.sollto=document.documentElement.scrollTop;
          setTimeout(()=>{this.kuan=true},20)
         }       
      },
      onso(){
       window.addEventListener('scroll',this.winon)
      },
      /*轮播定时*/
      marginLe(){
        this.time=setInterval(()=>{
          if(this.aa){         
           this.marginL++;
           if(this.marginL>700){
             this.aa=false
           }
          }else{
           this.marginL--;
           if(this.marginL==0){
             this.aa=true
           }
          }
        },20)
      },
      clti(){
        window.clearInterval(this.time)
      },
      /*面板切换*/
      ishowmian(id){
       this.ishow=id;
       this.axios.get(`goods/show/?type=${id}`).then((res)=>{this.limian=res.data;})
      }
   },
   created(){
     this.marginLe();
     this.axios.get('new/all').then((res)=>{this.newal=res.data;});
     this.axios.get('gType/all').then((res)=>{this.lity=res.data;});
     this.axios.get('goods/show/?type=1').then((res)=>{this.limian=res.data;})
   },
    mounted(){
     this.onso();
   },
   destroyed(){
     window.removeEventListener('scroll',this.winon)
     this.clti()
   }
}
</script>
<style scoped>
#box{
  width: 300px;
  height: 175px;
  line-height: 30px;
  overflow: hidden;
  padding-left: 30px;
  border: 1px solid black;
  transition: all 0.5s;
}
.anim{
transition: all 0.5s;
}
#con1 li{
list-style: none;
line-height: 30px;
height: 30px;
}
.more{
  position: absolute;
  float: right;
  font-size:14px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(234,0,4,1);
  line-height: 40px;
  padding-right: 20px;
  position: absolute;
  right: 10px;
}
/*五大服务样式 */
.Lightning {
    width: 197px;
    height: 46px;
    background: #FF0000;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(255,255,255,1);
    line-height: 46px;
    /* text-align: center; */
    padding-left: 34px;
}
.fuwu{
  height: 500px;
  box-sizing: border-box;
  background: #e2e0e0;
  padding: 40px 0;
}
.p1{
  font-size: 24px;
  font-weight: bold;
  padding: 30px 0;
  text-align: center;
}
.p2{
  text-align: center;
  font-size: 14px;
  margin-bottom: 50px;
}
.mokuai,.mian{
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.div1{
  box-sizing: border-box;
  padding: 20px 10px;
  text-align: center;
}
.div1:hover{
  border:1px solid #FF0000;
  color:#FF0000;
}
.img11{
  background:url(../assets/wlw.jpg);
  background-size: 52px 52px;
}
.img22{
  background:url(../assets/ldcp.jpg);
  background-size: 52px 52px;
}
.img33{
  background:url(../assets/jyzb.jpg);
  background-size: 52px 52px;
}
.img44{
  background:url(../assets/sjjc.jpg);
  background-size: 52px 52px;
}
.img55{
  background:url(../assets/jzgc.jpg);
  background-size: 52px 52px;
}
.img66{
  background:url(../assets/txgc.jpg);
  background-size: 52px 52px;
}
.img1:hover .img11{
  background:url(../assets/wlw2.jpg);
  background-size: 52px 52px;
  }
  
.img2:hover .img22{
  background:url(../assets/ldcp2.jpg);
  background-size: 52px 52px;
}
.img3:hover .img33{
  background:url(../assets/jyzb2.jpg);
  background-size: 52px 52px;
}
.img4:hover .img44{
  background:url(../assets/sjjc2.jpg);
  background-size: 52px 52px;
}
.img5:hover .img55{
  background:url(../assets/jzgc2.jpg);
  background-size: 52px 52px;
}
.img6:hover .img66{
  background:url(../assets/txgc2.jpg);
  background-size: 52px 52px;
}
.div1>p{
  font-size: 14px;
  height: 84px;
  overflow: hidden;
}
.mokuai>div{
   width: 166px;
  height: 153px;
 background:#fff;
}
/*产品解决方案 */
.mian{
  border: 1px solid #d9d9d9;
}
.mian>ul>li{
  height: 41px;
  line-height: 41px;
  text-align: center;
  cursor: pointer;
   background: #d9d9d9;
   position: relative;
}
.mian>ul{
     box-sizing: border-box;
     width: 231px;
}
.mian>div{
     box-sizing: border-box;
     width: 990px;
     display: flex;
     flex-flow: wrap;
         position: relative;
}
.li:hover{
 color: #FF0000;
}
.li .sanjiao{
    border-left: 10px solid red;
}
.li:hover .sanjiao{
    border-left: 10px solid red;
}
.sanjiao{
    position: absolute;
    width: 0;
    height: 0;
    left: 45px;
    top: 18px;
    border-top: 5px solid transparent;
    border-left: 10px solid black;
    border-bottom: 5px solid transparent;
}
.kuai{
  box-sizing: border-box;
  padding: 40px 20px;
  display: flex;
  cursor: pointer;
 
}
.kuai-jie{
  width: 275px;
  padding-left: 15px;
}
.kuai-jie>h4{
  margin-bottom: 10px;
  height: 20px;
    overflow: hidden;
}
.kuai-jie>p{
  height: 40px;
  font-size: 12px;
  overflow: hidden;
}
.btn{
  width: 88px;
  padding: 3px;
  font-size: 13px;
  color: white;
  background: red;
  border-radius: 7px;
  text-align: center;
  cursor: pointer;
}
/*工作案例 */
.work{
  width: 1200px;
  margin:0 auto;
  display: flex;
  justify-content: space-between;
  flex-flow: wrap;
  margin-bottom:30px;
}
.work>div{
  position: relative;
  width: 210px;
  background: #fff;
  box-shadow: 0px 1px 10px 2px rgb(177, 174, 174);
}
/*新闻中心*/
.xinwen{
  width: 1200px;
  margin: 0 auto 0;
}
.xin{
   background: rgba(245,245,245,1);
   display: flex;
}
.xin>div:first-child{
  margin:0 35px;
  height: 234px;
  position: relative;
}
.xin>div:last-child{
  box-sizing: border-box;
  padding: 20px 20px;
  width: 850px;
  height: 234px;
  overflow: hidden;
}
.yi{
  position: absolute;
  bottom: 0px;
  background: rgba(8, 7, 7, 0.5);
  height: 0px;
  transition: .8s;
  overflow: hidden;
  color: #fff;
  text-align: center;
}
.yi>p{
  font-size: 12px;
}
.xinwen:hover .yi{
  height: 55px;
}
.right{
  font-size: 13px;
}
.right>p:first-child{
  font-weight: 800;
  padding:10px 0;
}
/*荣誉资质 */ 
.rong>div>div{
  width: 170px;
  height: 235px;
  display: flex;
  align-items: center;
}
.rong>div>div+div{
  margin-left: 30px;
}
.rong>div{
  width: 1800px;
   display: flex;
   margin-left: -0px;
}
.rong{
  overflow: hidden;
  width: 1200px;
  margin:0 auto;
  
  margin-bottom:30px;
}
.fixed{
  position:fixed;
  width: 50px;
  height: 200px;
  background: red;
  bottom: 59px;
  right: 47px;
}
</style>
